
// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('AppNav')

class AppNav extends React.PureComponent {
  renderItem(item) {
    return (
      tag('a', {
        key: item.href,
        className: bem.element('item', {
          selected: this.props.selected === item.href
        }),
        href: item.href
      },
        item.title
      )
    )
  }

  render() {
    const { hidden, items } = this.props
    if (hidden || !items.length) {
      return null
    }
    return (
      tag('div', {
        className: classNames(
          this.props.className,
          bem.block()
        )
      },
        items.map(item => this.renderItem(item))
      )
    )
  }
}

AppNav.propTypes = {
  // Values
  className: PropTypes.string,
  hidden: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  })).isRequired,
  selected: PropTypes.string
}

module.exports = AppNav
